import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { ConfirmationService } from "primeng/api";
import { ButtonModule } from "primeng/button";
import { DialogModule } from "primeng/dialog";
@Component({
  selector: "app-ok-dialog",
  standalone: true,
  imports: [CommonModule, DialogModule, ButtonModule, TranslateModule],
  templateUrl: "./ok-dialog.component.html",
  styleUrl: "./ok-dialog.component.scss",
  providers: [ConfirmationService],
})
export class OkDialogComponent {
  @Input() title: string | undefined;
  @Input() message: string | undefined;
  @Input() okLabel!: string;
  @Input() cancelButton!: boolean;
  @Output() closeDialogEvent = new EventEmitter<boolean>();

  isVisible = true;

  closeDialog(event: boolean) {
    this.closeDialogEvent.emit(event);
    this.isVisible = false;
  }
}
